import { render, staticRenderFns } from "./UnifiedSearchModal.vue?vue&type=template&id=4721a55a&scoped=true"
import script from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
export * from "./UnifiedSearchModal.vue?vue&type=script&lang=ts"
import style0 from "./UnifiedSearchModal.vue?vue&type=style&index=0&id=4721a55a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721a55a",
  null
  
)

export default component.exports